export const DEFAULT_PAGE = 1;
export const PER_PAGE = 10;
export const ASC = "asc";
export const DESC = "desc";
export const AUTH_ID = "AuthId";
export const AUTHDESC = "DESC";
export const SECRET_KEY = "HealthPlanPortal_Key";
export const SALT = "HealthPlanPortal_Salt";
export const ITERATIONS = 100000;
